var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShopNonSelectedCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 8150",
    d: "M1 1H3.90954L5.86297 9.92639C5.92933 10.2327 6.1109 10.5079 6.376 10.7041C6.64111 10.9002 6.97294 11.0049 7.31362 10.9998H14.3839C14.7248 11.0052 15.0571 10.9008 15.3225 10.7046C15.588 10.5084 15.7698 10.2329 15.8362 9.92639L17 4.33654H4.63651",
    stroke: "#999899",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8151",
    d: "M9 14.5C9 14.7967 8.91203 15.0867 8.7472 15.3334C8.58238 15.58 8.34811 15.7723 8.07403 15.8858C7.79994 15.9994 7.49834 16.0291 7.20737 15.9712C6.91639 15.9133 6.64912 15.7704 6.43934 15.5607C6.22956 15.3509 6.0867 15.0836 6.02882 14.7926C5.97094 14.5017 6.00065 14.2001 6.11418 13.926C6.22771 13.6519 6.41997 13.4176 6.66664 13.2528C6.91332 13.088 7.20333 13 7.5 13C7.89783 13 8.27936 13.158 8.56066 13.4393C8.84196 13.7206 9 14.1022 9 14.5Z",
    fill: "#999899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8152",
    d: "M16 14.5C16 14.7967 15.912 15.0867 15.7472 15.3334C15.5824 15.58 15.3481 15.7723 15.074 15.8858C14.7999 15.9994 14.4983 16.0291 14.2074 15.9712C13.9164 15.9133 13.6491 15.7704 13.4393 15.5607C13.2296 15.3509 13.0867 15.0836 13.0288 14.7926C12.9709 14.5017 13.0006 14.2001 13.1142 13.926C13.2277 13.6519 13.42 13.4176 13.6666 13.2528C13.9133 13.088 14.2033 13 14.5 13C14.8978 13 15.2794 13.158 15.5607 13.4393C15.842 13.7206 16 14.1022 16 14.5Z",
    fill: "#999899"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopNonSelectedCu);
export default __webpack_public_path__ + "static/media/icon-shop-non-selected-cu.e3f88366acb6ba71ce68c55014ff744a.svg";
export { ForwardRef as ReactComponent };